import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, output } from '@angular/core';

import { TableItem } from '../../../domain/models/table-item';
import {
  CloseType,
  TableService,
} from '../../../domain/services/table.service';
import { CurrencyPipe } from '../../../pipes/currency.pipe';
import { IconComponent } from '../../../components/icon/icon.component';
import { ButtonIconComponent } from '../../../components/button/button-icon.component';

@Component({
  selector: 'app-item-table',
  imports: [
    CommonModule,
    CurrencyPipe,
    IconComponent,
    ButtonIconComponent,
  ],
  templateUrl: './item-table.component.html',
  styleUrl: './item-table.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ItemTableComponent {
  @Input() item: TableItem;
  @Input() type?: CloseType;
  @Input() tax?: boolean;
  @Input() last = false;
  increasedItem = output<boolean>();
  qty: number = 0;
  isChecked: boolean = false;
  canIncrease: boolean = true;

  constructor(private tableService: TableService) {}

  ngAfterContentInit() {
    this.isChecked = !!this.item.qtySelected;
    this.checkCanIncrease();
    this.qty = this.item.qtyGrouped || this.item.qty;
  }

  get value(): number {
    // Em PARTIAL com algo selecionado, mostra o preço proporcional ao que vai
    // pagar (item.value × qtySelected). Caso contrário, mostra o total do grupo
    // ou do item — o que o usuário ainda não selecionou.
    if (this.item.qtySelected > 0) {
      return this.item.value * this.item.qtySelected;
    }
    if (this.item.qtyGrouped) {
      return this.item.valueGrouped;
    }
    return this.item.value * this.item.qty;
  }

  toggle() {
    if (!this.isChecked && !this.tax) {
      this.isChecked = !this.isChecked;
      this.handlePlus();
    }
  }

  uncheck(event: any) {
    if (!this.tax) {
      event.stopPropagation();
      if (this.isChecked) {
        this.isChecked = false;
        this.tableService.decreaseTotalItemSelected(this.item, true);
        this.checkCanIncrease();
        this.increasedItem.emit(false);
      } else {
        this.toggle();
      }
    }
  }

  stopPropagation(event: any) {
    event.stopPropagation();
  }

  handleSelect(event: any) {
    event.stopPropagation();
    this.toggle();
  }

  handlePlus() {
    this.checkCanIncrease();
    if (this.qty > this.item.qtySelected) {
      this.tableService.increaseTotalItemSelected(this.item,this.qty);
      this.checkCanIncrease();
      this.increasedItem.emit(true);
    }
  }

  handleSub() {
    if (this.item.qtySelected == 1 || this.item.type == 'WEIGHTABLE') {
      this.isChecked = false;
    }
    this.tableService.decreaseTotalItemSelected(this.item);
    this.checkCanIncrease();
    this.increasedItem.emit(true);
  }

  checkCanIncrease() {
    this.canIncrease = this.qty > this.item.qtySelected;
  }
}
